/**
 * 获取表情包列表
 */
export async function fetchStickerList() {
  return http
    .get<GetStickerRes>('/v1/emoji_pack/list')
    .then((res) => {
      // 转换成[{name: 'xxx', list: [{name: 's-1', url: 'xxx', desc: 'xxx'}]
      const key1 = Object.keys(res.data)
      const result: StickerList[] = []
      for (let i = 0; i < key1.length; i++) {
        const key2 = Object.keys(res.data[key1[i]].list)
        const list: Sticker[] = []
        for (let j = 0; j < key2.length; j++) {
          list.push({
            // name 是key-key
            name: `${key1[i]}-${key2[j]}`,
            url: res.data[key1[i]].list[key2[j]].url,
            desc: res.data[key1[i]].list[key2[j]].desc
          })
        }
        result.push({
          name: res.data[key1[i]].name,
          list
        })
      }
      return result
    })
    .catch(() => [] as StickerList[])
}
